import classNames from "classnames";
import type { ReactNode } from "react";
import styles from "./InfoBox.module.scss";

export type InfoBoxTone = "info" | "primary" | "warning" | "success" | "error";

/** A tinted callout box (replaces inline alert/status/diagnose banners). */
export function InfoBox({
  tone = "info",
  icon,
  children,
}: {
  tone?: InfoBoxTone;
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={classNames(styles.infoBox, styles[`tone-${tone}`])}>
      {icon != null && <span className={styles.infoIcon}>{icon}</span>}
      <div className={styles.infoBody}>{children}</div>
    </div>
  );
}
